module.exports = {
  title: '商家优惠券统计',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'seller-coupon-list',
    },
  },
};
